import { Auth } from 'aws-amplify';

/**
 * @returns {Array} - array of strings representing the groups of the current user
 */
export const getUserGroups = async () => {
  const session = await Auth.currentSession();
  const userGroups = session.idToken.payload['cognito:groups'];
  return userGroups;
};

/**
 * NOTE: currently placeholders for proof of concept
 * @param {String} group - group of cognito user
 * @returns {Array} - array of objects of available apps for provided group
 */
export const getAvailableApps = (group) => {
  let apps = [];
  switch (group) {
    case 'Center_Owner':
      apps = [
        { appName: 'Center Admin', url: '/center_admin', description: 'Lorem ipsum dolor sit amet.' },
        { appName: 'Rooming', url: '/rooming', description: 'Excepteur sint occaecat cupidatat.' },
        { appName: 'Parent', url: '/parent', description: 'sed do eiusmod tempor.  sed do eiusmod tempor.' }
      ];
      break;
    case 'KT_Admin':
      apps = [
        { appName: 'KT Admin', url: '/kt_admin', description: 'Duis aute irure dolor in reprehenderit' },
        { appName: 'Center Admin', url: '/center_admin', description: 'Lorem ipsum dolor sit amet.' },
        { appName: 'Rooming', url: '/rooming', description: 'Excepteur sint occaecat cupidatat.' },
        { appName: 'Parent', url: '/parent', description: ' sed do eiusmod tempor.  sed do eiusmod tempor.' }
      ];
      break;
    case 'Parent':
      apps = [
        { appName: 'Parent', url: '/parent', description: 'sed do eiusmod tempor.  sed do eiusmod tempor.' }
      ];
      break;
    default:
      break;
  }

  return apps;
};
